import * as React from "react";
import { useIsMobile } from "./use-mobile";
import {
  InterviewLayoutMode,
  resolveInterviewLayoutMode,
} from "../lib/interviewLayoutMode";

function getCurrentSearch(): string {
  return typeof window === "undefined" ? "" : window.location.search;
}

export function useInterviewLayoutMode(): InterviewLayoutMode {
  const isMobileViewport = useIsMobile();
  const [search, setSearch] = React.useState(getCurrentSearch);

  React.useEffect(() => {
    const updateSearch = () => setSearch(getCurrentSearch());
    window.addEventListener("popstate", updateSearch);
    window.addEventListener("hashchange", updateSearch);
    return () => {
      window.removeEventListener("popstate", updateSearch);
      window.removeEventListener("hashchange", updateSearch);
    };
  }, []);

  return React.useMemo(
    () => resolveInterviewLayoutMode({ isMobileViewport, search }),
    [isMobileViewport, search]
  );
}
